import styled from "styled-components";
import isArray from "lodash/isArray";
import isObject from "lodash/isObject";

type LayoutBoxProps = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

type Margin = {
  margin?: Partial<LayoutBoxProps> | Partial<LayoutBoxProps>[];
};

type Padding = {
  padding?: Partial<LayoutBoxProps> | Partial<LayoutBoxProps>[];
};

const DEFAULT_VALUE: LayoutBoxProps = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};

function isLayoutBoxObj(
  layout: Partial<LayoutBoxProps> | Partial<LayoutBoxProps>[]
): layout is Partial<LayoutBoxProps> {
  return isObject(layout);
}

function isLayoutBoxArray(
  layout: Partial<LayoutBoxProps> | Partial<LayoutBoxProps>[]
): layout is Partial<LayoutBoxProps>[] {
  return isArray(layout);
}

function createLayoutBox(
  layoutBox: Partial<LayoutBoxProps> | Partial<LayoutBoxProps>[] | undefined
): LayoutBoxProps {
  if (!layoutBox) {
    return DEFAULT_VALUE;
  }

  if (isLayoutBoxObj(layoutBox)) {
    return { ...DEFAULT_VALUE, ...layoutBox };
  }

  if (isLayoutBoxArray(layoutBox)) {
    let resultLayout = { ...DEFAULT_VALUE };
    layoutBox.forEach((layoutItem: Partial<LayoutBoxProps>) => {
      resultLayout = { ...resultLayout, ...layoutItem };
    });
    return resultLayout;
  }

  return DEFAULT_VALUE;
}

const LayoutBox = styled.div<Margin & Padding>`
  margin: ${({ margin }): string => {
    const { top, right, bottom, left } = createLayoutBox(margin);
    return `${top}px ${right}px ${bottom}px ${left}px`;
  }};
  padding: ${({ padding }): string => {
    const { top, right, bottom, left } = createLayoutBox(padding);
    return `${top}px ${right}px ${bottom}px ${left}px`;
  }};
`;

export const lo = {
  overall: (num: number): LayoutBoxProps => ({
    top: num,
    right: num,
    bottom: num,
    left: num,
  }),
  horizontal: (num: number): Partial<LayoutBoxProps> => ({
    right: num,
    left: num,
  }),
  vertical: (num: number): Partial<LayoutBoxProps> => ({
    top: num,
    bottom: num,
  }),
};

export default LayoutBox;
